export default __webpack_public_path__ + "static/SR USA - Hoja de Seguridad - Color Caramelo (Liquido)-4099040c85145af02b250ec59b37b0b1.pdf";